import { type RefObject, useEffect, useLayoutEffect, useState } from "react";

const read = (key: string) => localStorage.getItem(key) ?? "";
const write = (key: string, text: string) =>
  text ? localStorage.setItem(key, text) : localStorage.removeItem(key);

export function useDraft(scope: string) {
  const key = `draft:${scope}`;
  const [value, setValue] = useState(() => read(key));
  const [draftKey, setDraftKey] = useState(key);
  if (draftKey !== key) {
    setDraftKey(key);
    setValue(read(key));
  }
  useEffect(() => write(key, value), [key, value]);
  const clear = () => write(key, "");
  return [value, setValue, clear] as const;
}

export function useCaretToEndOnMount(
  ref: RefObject<HTMLTextAreaElement | null>
) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (el) el.setSelectionRange(el.value.length, el.value.length);
  }, [ref]);
}
